var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgReplay = function SvgReplay(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22q-1.874 0-3.512-.712a9.2 9.2 0 0 1-2.85-1.925 9.2 9.2 0 0 1-1.925-2.85A8.7 8.7 0 0 1 3 13q0-.424.288-.713A.97.97 0 0 1 4 12q.424 0 .713.287Q5 12.576 5 13q0 2.925 2.037 4.962T12 20t4.962-2.038T19 13t-2.038-4.962T12 6h-.15l.85.85q.3.3.288.7-.014.4-.288.7-.3.3-.712.313a.93.93 0 0 1-.713-.288L8.7 5.7a.96.96 0 0 1-.3-.7q0-.4.3-.7l2.575-2.575a.93.93 0 0 1 .713-.287q.412.012.712.312.275.3.288.7a.92.92 0 0 1-.288.7l-.85.85H12q1.874 0 3.512.713a9.2 9.2 0 0 1 2.85 1.925 9.2 9.2 0 0 1 1.926 2.85A8.7 8.7 0 0 1 21 13q0 1.874-.712 3.512a9.2 9.2 0 0 1-1.925 2.85 9.2 9.2 0 0 1-2.85 1.926A8.7 8.7 0 0 1 12 22"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReplay);
export { ForwardRef as ReactComponent };